import { createFileRoute } from '@tanstack/react-router';
import { CostChangesPage } from '@/features/purchasing/CostChangesQueue';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/cost-changes')({
  component: Page,
});
function Page() {
  const { supplierId } = Route.useSearch();
  return <CostChangesPage supplierId={supplierId} />;
}
